import { type Api } from '@myre/common-conf';
import { DynamicEnvService } from '@myre/ui-domain-http';

import {
  type HttpEvent,
  type HttpHandler,
  type HttpInterceptor,
  type HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { type Observable } from 'rxjs';

export abstract class AbstractInterceptor implements HttpInterceptor {
  protected readonly _dynamicEnvService = inject(DynamicEnvService);

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const api = this._dynamicEnvService.getApiFromUrl(req.url);

    if (!api) {
      return next.handle(req);
    }

    return this._handle(req, next, api);
  }

  protected _handle(
    req: HttpRequest<any>,
    next: HttpHandler,
    _: Api,
  ): Observable<HttpEvent<any>> {
    return next.handle(req);
  }
}
